export default "__VITE_ASSET__D7h_$$gt__"